module.exports = __webpack_public_path__ + "static/img/equipment2.7f3b7f0e.png";